import React, { useEffect, useState } from "react";
import { Image } from "react-bootstrap";
import { IMAGES } from "../images/images";
import { Link } from "react-router-dom";
import { Img, Section, Txt } from "../cms/Cms";
import { LEGAL_PAGES } from "../pages/LegalPage";

// Footer icons in display order. Each opens the link set in the admin panel
// (Landing Page → Social links); an icon the admin hid, or one with no
// link, is not shown.
// A plain https link opens the Facebook/Instagram app on phones where it is
// installed (universal / app links) and the website otherwise.
const SOCIAL_ICONS = [
  { key: "facebook", icon: IMAGES.Icon1, label: "Facebook", duration: "1500" },
  { key: "twitter", icon: IMAGES.Icon2, label: "X (Twitter)", duration: "2000" },
  { key: "instagram", icon: IMAGES.Icon3, label: "Instagram", duration: "2100" },
  { key: "pinterest", icon: IMAGES.Icon4, label: "Pinterest", duration: "2200" },
  { key: "linkedin", icon: IMAGES.Icon5, label: "LinkedIn", duration: "2500" },
];

const Footer = () => {
  const [socialLinks, setSocialLinks] = useState({});

  useEffect(() => {
    fetch("https://omni-cave.com/backend/api/v1/auth/get-app-config")
      .then((res) => res.json())
      .then((res) => {
        if (res && res.success) setSocialLinks(res.body?.social_links || {});
      })
      .catch(() => {});
  }, []);

  return (
    <Section id="footer" label="Footer">
      <section
        className="footer"
        style={{ backgroundImage: `url(${IMAGES.FooterBg_Img})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <Img
                k="footer_logo_img"
                src={IMAGES.Whitelogo_Img}
                slotWidth={246}
                slotHeight={139}
                data-aos="fade-up"
                data-aos-duration="1500"
                className="flogo img-fluid"
                label="Logo"
              />
              <div className="foot_links">
                <ul>
                  {/* <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/">About Us</Link>
                  </li> */}
                  <li data-aos="fade-right" data-aos-duration="1500">
                    <Link to={LEGAL_PAGES.privacy.path}>
                      <Txt k="footer_privacy">Politique de confidentialité</Txt>
                    </Link>
                  </li>
                  <li data-aos="fade-up" data-aos-duration="1500">
                    <Link to={LEGAL_PAGES.terms.path}>
                      <Txt k="footer_terms">Conditions générales d'utilisation</Txt>
                    </Link>
                  </li>
                  <li data-aos="fade-left" data-aos-duration="1500">
                    <Link to="/contact">
                      <Txt k="footer_contact">Nous contacter</Txt>
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="social_links">
                {SOCIAL_ICONS.filter(({ key }) =>
                  /^https:\/\//i.test(socialLinks[key] || "")
                ).map(({ key, icon, label, duration }) => (
                  <a
                    key={key}
                    href={socialLinks[key]}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                  >
                    <Image
                      data-aos="zoom-in"
                      data-aos-duration={duration}
                      src={icon}
                      alt={label}
                    />
                  </a>
                ))}
              </div>
            </div>
            {/* No scroll animation: the copyright is the last line of the page,
                so it never scrolled far enough up to trigger and stayed invisible. */}
            <div className="copyright">
              <p className="mb-0">
                <Txt k="footer_copyright">{`© ${new Date().getFullYear()} OmniCave. Tous droits réservés.`}</Txt>
              </p>
            </div>
          </div>
        </div>
      </section>
    </Section>
  );
};

export default Footer;
